export default class Form {
    constructor() {
        this.init();
    }

    init() {
        this.addCheck();
    }

    addCheck() {
        const $form = document.querySelector('.js-form');
        const $check = $form.querySelector('.aword2021__qa__elem_check');
        const checked = () => $check.checked ? $form.classList.add('-check') : $form.classList.remove('-check');

        checked();

        $check.addEventListener('click', checked);
    }
}